import { proxy } from 'valtio';
import { StepIndexerState } from 'hooks/useStepIndexer';

export const cepFormStepIndexer = proxy<StepIndexerState>({
  stepIndex: 0,
  previousStep: 0,
});
